import logo from './logo.svg';
import './App.css';
import Layout from './Layout';

function App() {

  document.title = "Prezentacja systemu eLizak";

  return (
    <div className="App">
          <Layout/>
    </div>
  );
}

export default App;
